// extracted by mini-css-extract-plugin
export default {"wrapper":"pS-z","availablePromoMessagesLabel":"qS-z","promoMessageList":"rS-z","promoMessage":"sS-z","appliedPromoMessage":"tS-z","promoMessageAmount":"uS-z"};